export const AUTHENTICATING = "Authenticating...";
export const ERROR_AUTHENTICATING = "An error occured during authentication, please try again!";
export const REGULATION_UPDATE_SUCCESS = "Regulations has been updated successfully";